import { IRestaurant, ListItem, Pill, RestaurantSubscription } from '@localina/core';
import { RestaurantIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    restaurant: IRestaurant;

    subscription?: RestaurantSubscription;

    isCurrent?: boolean;
    onClick: (restaurant: IRestaurant) => void;
}

export const RestaurantListItem: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { street, streetNumber, postalCode, city } = props.restaurant.info;
    const address = `${street} ${streetNumber} · ${postalCode} ${city}`;

    const handleClick = () => {
        props.onClick(props.restaurant);
    };

    return (
        <ListItem
            classNames={`restaurant-listitem${props.isCurrent ? ' is-current' : ''}`}
            leftIcon={
                <span className="restaurant-listitem__icon">
                    <RestaurantIcon />
                </span>
            }
            title={
                <div className="restaurant-listitem__row">
                    <div className="restaurant-listitem__main">
                        <span className="restaurant-listitem__name">{props.restaurant.info.name}</span>
                        <span className="restaurant-listitem__address">{address}</span>
                    </div>
                    {}
                    {Boolean(props.subscription) && (
                        <Pill
                            tone={props.subscription === RestaurantSubscription.STANDARD ? 'teal' : 'neutral'}
                            label={t(`restaurants.subscription.${props.subscription}`)}
                        />
                    )}
                    {props.isCurrent && <Pill tone="good" label={t('restaurants.current')} />}
                </div>
            }
            onClick={handleClick}
        />
    );
};
